// src/components/Dashboard/FlowBits.jsx
//
// Piezas compartidas por el panel de pasos del reclamo (ClaimFlowPanel) y
// la tarjeta de cada cheque (CheckCard): qué hay que hacer, el plazo del
// paso (config/flowRules.js), lo que falta para avanzar y los mensajes.
import React from 'react';
import { describeRemaining } from '../../config/flowRules';
import './ClaimFlow.css';

const TIMER_STYLE = {
  ok: ['cd-status-count', 'fa-regular fa-clock'],
  warning: ['cd-status-pending', 'fa-solid fa-hourglass-half'],
  overdue: ['cd-status-overdue', 'fa-solid fa-triangle-exclamation'],
  waiting: ['cd-status-count', 'fa-regular fa-clock'],
  ready: ['cd-status-paid', 'fa-solid fa-unlock']
};

// Etiqueta corta del plazo: "Vence en 1 día(s)", "Venció hace 3 h", "Se habilita en 20 día(s)".
export const timerText = (timer, es) => {
  if (!timer) return '';
  const when = describeRemaining(timer.remainingMs, es);
  if (timer.kind === 'unlock') return timer.status === 'ready' ? (es ? 'Habilitado' : 'Enabled') : `${es ? 'Se habilita' : 'Enabled'} ${when}`;
  return timer.status === 'overdue' ? `${es ? 'Venció' : 'Overdue'} ${when}` : `${es ? 'Vence' : 'Due'} ${when}`;
};

export const TimerBadge = ({ timer, es }) => {
  if (!timer) return null;
  const [cls, icon] = TIMER_STYLE[timer.status] || TIMER_STYLE.ok;
  return <span className={`cd-status-badge ${cls}`}><i className={icon}></i> {timerText(timer, es)}</span>;
};

// Plazo del paso con su explicación (y el aviso cuando venció).
export const TimerNotice = ({ timer, es, children }) => {
  if (!timer) return null;
  const tone = timer.status === 'overdue' ? 'is-overdue' : timer.status === 'warning' ? 'is-warning' : '';
  return (
    <div className={`flow-timer-box ${tone}`}>
      <div className="flow-timer-head">
        <strong>{es ? timer.label[0] : timer.label[1]}</strong>
        <TimerBadge timer={timer} es={es} />
      </div>
      <div className="flow-timer-due">
        {es ? 'Fecha límite' : 'Due'}: {new Date(timer.dueAt).toLocaleString(es ? 'es' : 'en-US', { dateStyle: 'medium', timeStyle: 'short' })}
      </div>
      {timer.message && <div className="flow-timer-message">{es ? timer.message[0] : timer.message[1]}</div>}
      {children}
    </div>
  );
};

export const StepHelp = ({ help, es }) => (help ? <p className="flow-help"><i className="fa-solid fa-circle-info"></i> {es ? help.es : help.en}</p> : null);

export const BlockerList = ({ blockers, es }) => {
  if (!blockers?.length) return null;
  return (
    <div className="flow-blockers" role="status">
      <strong>{es ? 'Para continuar falta:' : 'To continue:'}</strong>
      <ul>{blockers.map(b => <li key={b.es}>{es ? b.es : b.en}</li>)}</ul>
    </div>
  );
};

// Mensaje de error de completeStep/moveToStep, en claro.
export const flowErrorMessage = (error, es) => {
  if (error?.message === 'BLOCKED') return (error.blockers || []).map(b => (es ? b.es : b.en)).join(' ');
  if (error?.message === 'STEP_CHANGED') return es ? 'Otra persona movió esto mientras lo tenías abierto. Recarga la página.' : 'Someone else moved this. Reload the page.';
  if (error?.message === 'NOT_ALLOWED') return es ? 'No tienes permiso para este paso.' : 'You are not allowed to act on this step.';
  return es ? 'No se pudo completar el paso.' : 'Could not complete the step.';
};
